export const SALESMAN_SAVE = 'SALESMAN_SAVE';